export let dataProps = {
    id: 0,
    collection_name: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringCollection/properties.js